const pageDesignerIds = {
    homepage: "homepage",
    landingpage: "lp",
    category: "clp"
};

const REGEX = {
    EMAIL: /^[\w.%+-]+@[\w.-]+\.[\w]{2,10}$/
};

const PRIMARY_CATEGORY_IDS = {
    INTERNET  : 21,
    CELLPHONE : 22,
    LANDLINE  : 19
};

const LEGAL_ENTITY = {
    PF : "PF",  // "Pessoa Física" only;
    PJ : "PJ",  // "Pessoa Jurídica" only;
    PFJ: "PFJ", // "Pessoa Física" and "Pessoa Jurídica";
};

const CUSTOMER_DOCUMENT = {
    CPF: "CPF",
    CNPJ: "CNPJ",
};

const TILE_TYPE = {
    OFFER   : "offer",
    PRODUCT : "product",
    SERVICE : "service"
};

const SALE_TYPE = {
    NV: "NV", // Nova venda
    AT: "AT", // Alteração
    MI: "MI", // Migração, que é equivalente a Alteração
};

const PRODUCT_SALE_TYPE = {
    NEW_SALE : "NOVA_VENDA",
    UPDATE   : "ALTERACAO"
};

const UPDATE_OPERATION_TYPE = {
    CHANGE: "AT",
    MIGRATION: "MI"
};

const TERRITORY_TYPE = {
    CONCESSAO: "CONCESSAO", // Concessão
    EXPANSAO: "EXPANSAO", // Expansão
};

const DOCUMENT_TYPE = {
    RG: "RG",
    RG_BACK: "RG_BACK",
    RG_FRONT: "RG_FRONT",
    CNH: "CNH",
    RNE: "RNE",
    RNM: "RNM",
    RNM_BACK: "RNM_BACK",
    RNM_FRONT: "RNM_FRONT",
    PASSPORT: "PASSPORT",
    CNPJ: "CNPJ",
    LIVENESS_VIDEO: "LIVENESS_VIDEO"
};

const DOCUMENTATION_VALID_FILE_TYPES = [
    "png", "jpeg", "jpg", "ppm", "tiff", "pdf"
];

const STANDALONE_ID = "NONE";

const CLIENT_INTERACTION = {
    VALIDATION_TYPE: {
        QUIZ: "QUIZ",
        BACKGROUND_CHECK: "BACKGROUND_CHECK",
        EXTERNALBGC: "EXTERNALBGC",
        NONE: "NONE"
    }
};

const KEYBOARD_KEYS = {
    TAB: 9,
    ENTER: 13,
    ESC: 27,
    SPACE: 32,
    ARROW_UP: 38,
    ARROW_DOWN: 40,
    BACKSPACE: "Backspace",
    DELETE: "Delete"
};

const ACCESSIBILITY_KEYS = {
    ZOOM_LEVEL: "zoom_level",
    ZOOM_STEPS: 5
};

// Geolocation Constants

const GEOLOCATION = {
    OPTIONS: {
        enableHighAccuracy: false, // Prefered to use in false, since it could change decimal values on accuracy with no need
        maximumAge: 5000,
        timeout: 10000,
    },
    STATUS_CODES: {
        PERMISSION_GRANTED: 0,
        PERMISSION_DENIED: 1,
        POSITION_UNAVAILABLE: 2,
        TIMEOUT: 3,
    },
    SESSION_STORAGE_KEYS: {
        COORDINATES: "GeolocationCoordinates",
        PERMISSION_STATUS: "GeolocationPermissionStatus"
    },
    MIN_DISTANCE_THRESHOLD: 10000, // Minimum distance threshold in meters between two geolocation coordinates
    IS_CITY_NOTIFICATION_DISMISSED: "IsCityNotificationDismissed",
    GOT_USER_FIRST_GEOLOCATION: "GotUserFirstGeolocation"
};

const PHONE_TYPE = {
    NEW         : "new",
    PORTABILITY : "portability"
};

const PHONE_CHIP_TYPE = {
    ESIM : "esim",
    SIMCARD: "simcard"
};

const APPLIANCE = {
    MESSAGE_WPP: "Olá! Gostaria de informações sobre o produto ",
    MESSAGE_WPP_END: " que vi no site."
};

const LEAD_TYPE = {
    PROSPECCAO: { id: 3 },
    RENTABILIZACAO: { id: 4 }
};

const ADD_PRODUCT_TO_CART_SOURCE = {
    OFFER_TILE: "OFFER_TILE",
    OFFER_BANNER: "OFFER_BANNER",
    LANDING_PAGE: "LANDING_PAGE",
    CART: "CART",
    MY_ACCOUNT: "MY_ACCOUNT",
    EXTERNAL: "external"
};

const ADD_PRODUCT_TO_CART_TARGET = {
    CART: "cart"
};

const TAB_LIST = {
    PERSONAL: "personal",
    BUSINESS: "business",
    TIC_SOLUTIONS: "ticSolutions",
    GOVERNMENT: "clp-businessGoverno",
    GOVERNMENT_WITHOUT_PREFIX: "businessGoverno",
    WHOLESALE: "clp-businessAtacado",
    WHOLESALE_WITHOUT_PREFIX: "businessAtacado",
    INSTITUTIONAL: "clp-personal-Institucional"
};

const TAB_CONTROLLER_LIST = {
    personal: "Home-Personal",
    business: "Home-Business",
    ticSolutions: "Home-TicSolutions",
    "clp-businessGoverno": "Home-Government",
    "clp-businessAtacado": "Home-Wholesale",
    "clp-personal-Institucional": "Home-Institutional"
};

const FILE = {
    TERMS_PDF_FILENAME : "algar_termos_e_condicoes.pdf",
    TERMS_PDF_FILENAME_VAREJO : "termos_de_aceite_varejo.pdf",
    TERMS_PDF_FILENAME_MPE : "termos_de_aceite_mpe.pdf"
};

const GTM = {
    EVENTS: {
        SHOW_CART: "show_cart",
        SHOW_CART_NBO: "show_cart_nbo",
        ADD_TO_CART : "add_to_cart",
        ADD_TO_CART_NBO : "add_to_cart_nbo",
        REMOVE_FROM_CART : "remove_from_cart",
        MODIFY_CART : "modify_cart",
        VIEW_ITEM : "view_item",
        VIEW_ITEM_LIST : "view_item_list",
        VIEW_CART : "view_cart",
        BEGIN_CHECKOUT : "begin_checkout",
        BEGIN_CHECKOUT_NBO : "begin_checkout_nbo",
        PURCHASE : "purchase",
        PURCHASE_NBO : "purchase_nbo",
        ADD_SHIPPING_INFO : "add_shipping_info",
        ADD_INSTALL_ADDRESS_INFO : "add_install_address_info",
        ADD_PAYMENT_INFO : "add_payment_info",
        ORDER_CREATED : "order_created",
        PAYMENT_FAILED : "payment_failed",
        SELECT_ITEM : "select_item",
        PAGE_VIEW : "page_view",
        WHATSAPP_LINK : "Whatsapp link",
        SUCCESFULLY : "Succesfully",
        FAILED : "Failed",
        LIGAMOS_PARA_VOCE : "Ligamos para você",
        PURCHASE_VALIDATION: "purchase_validation",
        FORM_SUBMIT : "form_submit",
        LOGIN : "login",
        EMAIL : "Email",
        ERROR : "error",
        ERROR_404 : "Error 404",
        REGISTERED : "Registered",
        GUEST : "Guest",
        SELECT_PROMOTION : "select_promotion",
        START_PURCHASE_VALIDATION : "start_purchase_validation",
        START_PURCHASE_VALIDATION_NBO : "start_purchase_validation_nbo",
        SITE_SFCC : "site_sfcc",
        ABANDONED_CHECKOUT : "abandoned_checkout",
        ABANDONED_CART : "abandoned_cart",
        ABANDONED_PAYMENT : "abandoned_payment"
    },
    CHECKOUT_STEPS: {
        PERSONAL_DATA : "personal_data",
        DELIVERY_ADDRESS : "delivery_address",
        IDENTITY_VALIDATION : "identity_validation",
        ORDER_CREATED : "order_created",
        PAYMENT_GATEWAY : "payment_gateway",
        PAYMENT_ABANDONED : "payment_abandoned",
        PAYMENT_FAILED : "payment_failed",
        PAYMENT_APPROVED : "payment_approved",
        TRUSTCARD_REJECTED : "trustcard_rejected"
    },
    PRODUCT_FLOW: {
        APPLIANCE : "aparelho"
    },
    PHONE_INSURANCE_CHOICE: {
        INCLUDED    : "included",
        DECLINED    : "declined",
        SKIPPED     : "skipped",
        NOT_OFFERED : "not_offered"
    },
    ITEM_LIST_NAMES: {
        BANNER : "Banner (Área dos banners)",
        PACKAGE : "Pacote (Área dos pacotes)",
        CUSTOMIZE_PACKAGE : "Monte seu pacote - Cards (Área dos cards no monte seu pacote)",
        MENU : "Menu",
        DIRECT : "Direto",
        APPLIANCE : "Aparelho (PDP)",
        APPLIANCE_PLP : "Aparelhos (PLP)",
        APPLIANCE_INSURANCE : "Seguro Celular (Escolha de proteção)"
    },
    ADDITION_SOURCES: {
        OFFER_TILE: "OFFER_TILE",
        CART: "CART",
        OFFER_BANNER: "OFFER_BANNER",
        MY_ACCOUNT: "MY_ACCOUNT",
        EXTERNAL: "external"
    },
    ADD_PRODUCT_TO_CART_TYPE: {
        CHECKOUT: "Express checkout",
        CART: "Monte o seu pacote"
    },
    SEGMENTS: {
        personal: "Você",
        business: "Empresas",
        ticSolutions: "Soluções TIC",
        "clp-businessGoverno": "Governo",
        businessGoverno: "Governo",
        "clp-businessAtacado": "Atacado",
        businessAtacado: "Atacado",
        "clp-personal-Institucional": "Institucional"
    }
};

const MENU_CATEGORY = {
    ID: "menu",
    NAME: "menu-raiz"
};

const VIABILITY_TYPE = {
    CHECKOUT: "checkout",
    CART: "cart"
};

const CHANGE_PRODUCT_QUANTITY = 1;

const BILLING_MODALITY = {
    RECURRENT: "Recorrente",
    HYBRID: "Híbrida",
    PRE_PAID: "Pré-Pago",
    NONE: "Nenhuma",
};

const BACKGROUND_CHECK_TYPE = {
    WITH_LIVENESS: "WITH_LIVENESS",
    WITHOUT_LIVENESS: "WITHOUT_LIVENESS"
};

module.exports  = {
    pageDesignerIds                : pageDesignerIds,
    TERRITORY_TYPE                 : TERRITORY_TYPE,
    LEGAL_ENTITY                   : LEGAL_ENTITY,
    CUSTOMER_DOCUMENT              : CUSTOMER_DOCUMENT,
    SALE_TYPE                      : SALE_TYPE,
    PRODUCT_SALE_TYPE              : PRODUCT_SALE_TYPE,
    UPDATE_OPERATION_TYPE          : UPDATE_OPERATION_TYPE,
    STANDALONE_ID                  : STANDALONE_ID,
    PRIMARY_CATEGORY_IDS           : PRIMARY_CATEGORY_IDS,
    CLIENT_INTERACTION             : CLIENT_INTERACTION,
    FILE                           : FILE,
    GEOLOCATION                    : GEOLOCATION,
    PHONE_TYPE                     : PHONE_TYPE,
    PHONE_CHIP_TYPE                : PHONE_CHIP_TYPE,
    TILE_TYPE                      : TILE_TYPE,
    REGEX                          : REGEX,
    ADD_PRODUCT_TO_CART_SOURCE     : ADD_PRODUCT_TO_CART_SOURCE,
    ADD_PRODUCT_TO_CART_TARGET     : ADD_PRODUCT_TO_CART_TARGET,
    DOCUMENT_TYPE                  : DOCUMENT_TYPE,
    DOCUMENTATION_VALID_FILE_TYPES : DOCUMENTATION_VALID_FILE_TYPES,
    TAB_LIST                       : TAB_LIST,
    TAB_CONTROLLER_LIST            : TAB_CONTROLLER_LIST,
    GTM                            : GTM,
    KEYBOARD_KEYS                  : KEYBOARD_KEYS,
    ACCESSIBILITY_KEYS             : ACCESSIBILITY_KEYS,
    MENU_CATEGORY                  : MENU_CATEGORY,
    VIABILITY_TYPE                 : VIABILITY_TYPE,
    CHANGE_PRODUCT_QUANTITY        : CHANGE_PRODUCT_QUANTITY,
    APPLIANCE                      : APPLIANCE,
    BILLING_MODALITY               : BILLING_MODALITY,
    LEAD_TYPE                      : LEAD_TYPE,
    BACKGROUND_CHECK_TYPE          : BACKGROUND_CHECK_TYPE
};
